import { MailMigrationCheckKey } from '../mail_migration';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_MAIL_MIGRATION_CHECK = 'MAIL_MIGRATION_CHECK_';

export const MailMigrationCheckKeyTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_MAIL_MIGRATION_CHECK}${MailMigrationCheckKey.DOMAIN_ALIVE}`]: 'Domaine actif sur le site',
    [`${TRANSLATE_KEY_MAIL_MIGRATION_CHECK}${MailMigrationCheckKey.PRO_ACTIVE}`]: 'Pro v2 actif (abonnement en cours)',
    [`${TRANSLATE_KEY_MAIL_MIGRATION_CHECK}${MailMigrationCheckKey.RECOVERY_EMAILS}`]:
      'Adresse de récupération vérifiée pour chaque email du domaine',
    [`${TRANSLATE_KEY_MAIL_MIGRATION_CHECK}${MailMigrationCheckKey.INVENTORY_FRESH}`]:
      'Inventaire OVH à jour (moins de 24 h) avec au moins une boîte',
    [`${TRANSLATE_KEY_MAIL_MIGRATION_CHECK}${MailMigrationCheckKey.OVH_HOST_KNOWN}`]:
      'Offre et serveur IMAP OVH connus',
    [`${TRANSLATE_KEY_MAIL_MIGRATION_CHECK}${MailMigrationCheckKey.MAILBOX_SIZE}`]:
      'Aucune boîte au-dessus du quota maximal',
    [`${TRANSLATE_KEY_MAIL_MIGRATION_CHECK}${MailMigrationCheckKey.STALWART_CONFIGURED}`]:
      'Hébergement mail Propelsia configuré',
    [`${TRANSLATE_KEY_MAIL_MIGRATION_CHECK}${MailMigrationCheckKey.OVH_CLIENT_CONFIGURED}`]:
      'Clés OVH de migration configurées',
    [`${TRANSLATE_KEY_MAIL_MIGRATION_CHECK}${MailMigrationCheckKey.STALWART_MASTER_CONFIGURED}`]:
      'Accès IMAP maître Stalwart configuré (recopies sans toucher au mot de passe du pro)',
    [`${TRANSLATE_KEY_MAIL_MIGRATION_CHECK}${MailMigrationCheckKey.TTL_LOWERED}`]:
      'TTL des records mail OVH abaissé à 300 s',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  MailMigrationCheckKey,
  MailMigrationCheckKeyTranslation,
  TRANSLATE_KEY_MAIL_MIGRATION_CHECK,
  true,
);
